export { LandingShortcut } from './LandingShortcut';
